const fxNumElement = document.querySelector(".product-fx-number");
const productEan = document.querySelector("#product-ean");
const urlVariant = new URLSearchParams(window.location.search).get("variant");

const getFxNumber = (id) => {
  const variantData = variantsObject.variants[id];
  return variantData;
};

const observeUrlChange = () => {
  let oldHref = document.location.href;
  const body = document.querySelector("body");
  const observer = new MutationObserver((mutations) => {
    if (oldHref !== document.location.href) {
      oldHref = document.location.href;
      const urlVariant = new URLSearchParams(window.location.search).get("variant");
      const variantInfo = getFxNumber(urlVariant);

      if (!variantInfo) {
        return;
      }

      if (fxNumElement) {
        fxNumElement.textContent = variantInfo.fx;
      }

      if (productEan) {
        productEan.textContent = variantInfo.ean;
      }
    }
  });
  observer.observe(body, { childList: true, subtree: true });
};

window.onload = observeUrlChange;
